import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config } from "../../../shared";
import { VoucherContainer } from "../../../../../../../models/mongodbSchema/aggregates";

@Injectable({ providedIn: 'root' })
export class VoucherService extends BaseApiTemplateService<VoucherContainer>{
    constructor(private http: HttpClient){
        super()
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'voucher';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'voucher';
    this.httpClient = http;
    }

}